module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_common_blue.d8c09b27.gif";